import {
    FETCHED_REDIRECTS,
    FETCHED_REDIRECT,
    CREATED_REDIRECT,
    UPDATED_REDIRECT,
    DELETED_REDIRECT,
    FETCHED_STATUSES,
    ADD_BULK_REDIRECTS_DOCUMENT,
    DELETE_BULK_REDIRECTS_DOCUMENT,
    GET_BULK_UPLOAD_ERRORS,
    BULK_REDIRECTS_UPLOADED
} from './types';
import update from 'immutability-helper';

const INITIAL_STATE = {
    all: [],
    redirectSearchCriteria: '',
    allByTerms: [],
    redirect: {},
    statuses: [],
    touched: false,
    bulkDocument: {},
    bulkUploadErrors: []
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCHED_REDIRECTS:

            return update(state, {
                all: {$set: action.payload.data},
                bulkDocument: {$set: {}},
                bulkUploadErrors: {$set: []},
            });

        case FETCHED_STATUSES:

            return update(state, {
                statuses: {$set: action.statuses},
            });

        case FETCHED_REDIRECT:

            return update(state, {
                redirect: {$set: action.redirect},
            });

        case CREATED_REDIRECT:

            return update(state, {
                redirect: {$set: {} }
            });

        case UPDATED_REDIRECT:

            return update(state, {
                redirect: {$set: action.redirect},
            });

        case DELETED_REDIRECT:

            let allRedirects = state.all.filter(item => item.id !== action.redirect);

            return update(state, {
                all: {$set: allRedirects}
            });

        case ADD_BULK_REDIRECTS_DOCUMENT:

            return update(state, {
                bulkDocument: {$set: action.payload.document},
                touched: {$set: action.payload.touched}
            });

        case DELETE_BULK_REDIRECTS_DOCUMENT:

            return update(state, {
                bulkDocument: {$set: {}}
            });

        case GET_BULK_UPLOAD_ERRORS:

            return update(state, {
                bulkUploadErrors: {$set: action.bulkUploadErrors},
                bulkDocument: {$set: {}}
            });

        case BULK_REDIRECTS_UPLOADED:

            return update(state, {
                bulkUploadErrors: {$set: []},
                bulkDocument: {$set: {}}
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/redirects/reducer.js